import session from '@api/session'
import { APIEndpoint } from '@api/_version'

export default {
  login(username, password) {
    return session.post(APIEndpoint + '/auth/login/', { username, password })
  },
  // eslint-disable-next-line
  loginWithGoogle(data) {
    return session.post(APIEndpoint + '/auth/google/', data)
  },
  logout() {
    return session.post(APIEndpoint + '/auth/logout/', {})
  },
  createAccount(username, password1, password2, email, recatptchaToken, timezone) {
    const data = { username, password1, password2, email, timezone }
    data.recaptcha_token = recatptchaToken

    return session.post(APIEndpoint + '/auth/registration/', data)
  },
  // eslint-disable-next-line
  changeAccountPassword(old_password, new_password1, new_password2) {
    return session.post(APIEndpoint + '/auth/password/change/', {
      old_password,
      new_password1,
      new_password2,
    })
  },
  sendAccountPasswordResetEmail(email) {
    return session.post(APIEndpoint + '/auth/password/reset/', { email })
  },
  resetAccountPassword(uid, token, newPassword1, newPassword2) {
    // eslint-disable-line camelcase
    return session.post(APIEndpoint + '/auth/password/reset/confirm/', {
      uid,
      token,
      newPassword1,
      newPassword2,
    })
  },
  getAccountDetails() {
    return session.get(APIEndpoint + '/auth/user/')
  },
  updateAccountDetails(data) {
    return session.patch(APIEndpoint + '/auth/user/', data)
  },
  completeIntroSurvey(data) {
    return session.post(APIEndpoint + '/auth/registration/complete-intro-survey/', data)
  },
  verifyAccountEmail(key) {
    return session.get(APIEndpoint + '/auth/registration/verify-email/' + key + '/')
  },
  resendConfirmationEmail() {
    return session.get(APIEndpoint + '/auth/registration/account-resend-confirm-email/')
  },
  deleteAccount(data) {
    return session.delete(APIEndpoint + '/auth/user/', {data: data})
  },
}
